(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-contacto"] && !Shopify.designMode) return;
  try {
    
(function () {
  function aMinutos(hora) {
    if (!hora) return null;
    var partes = hora.split(':');
    if (partes.length !== 2) return null;
    return parseInt(partes[0], 10) * 60 + parseInt(partes[1], 10);
  }
  function grupoDelDia(diaSemana) {
    if (diaSemana === 0) return 'domingo';
    if (diaSemana === 6) return 'sabado';
    return 'entresemana';
  }
  function procesarSeccion(seccion) {
    var filas = seccion.querySelectorAll('[data-tb-grupo]');
    var ahora = new Date();
    var grupoHoy = grupoDelDia(ahora.getDay());
    var minutosAhora = ahora.getHours() * 60 + ahora.getMinutes();
    var abierto = false;
    filas.forEach(function (fila) {
      if (fila.getAttribute('data-tb-grupo') === grupoHoy) {
        fila.classList.add('tb-contacto-horario-fila--hoy');
        var cerrado = fila.getAttribute('data-tb-cerrado') === 'true';
        if (!cerrado) {
          var i1 = aMinutos(fila.getAttribute('data-tb-inicio1'));
          var f1 = aMinutos(fila.getAttribute('data-tb-fin1'));
          var i2 = aMinutos(fila.getAttribute('data-tb-inicio2'));
          var f2 = aMinutos(fila.getAttribute('data-tb-fin2'));
          if (i1 !== null && f1 !== null && minutosAhora >= i1 && minutosAhora < f1) {
            abierto = true;
          }
          if (i2 !== null && f2 !== null && minutosAhora >= i2 && minutosAhora < f2) {
            abierto = true;
          }
        }
      }
    });
    var badge = seccion.querySelector('[data-tb-badge-estado]');
    if (badge) {
      if (abierto) {
        badge.textContent = 'Abierto ahora';
        badge.classList.add('tb-contacto-badge-estado--abierto');
      } else {
        badge.textContent = 'Cerrado ahora';
        badge.classList.add('tb-contacto-badge-estado--cerrado');
      }
    }
  }
  function iniciar() {
    var secciones = document.querySelectorAll('.tb-contacto-seccion');
    secciones.forEach(function (seccion) {
      procesarSeccion(seccion);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
